import { Filter, FilterProps, ReferenceInput } from 'react-admin';
import FilterSearchOnButtonPress from '@/components/filters/FilterSearchOnButtonPress';
import { PartnerInputStyled } from '@/styles/overrides';
import { TurnReferencesEnum } from '@/types/turn-enums';

const AdverseFilter = (props: Partial<FilterProps>) => (
  <Filter {...props}>
    <ReferenceInput
      label="Partner"
      source="partner__id"
      reference={TurnReferencesEnum.AdminPartners}
      sort={{ field: 'name', order: 'ASC' }}
    >
      <PartnerInputStyled optionText="name" optionValue="id" translateChoice={false} />
    </ReferenceInput>
    <FilterSearchOnButtonPress source="q" label="Search" alwaysOn />
  </Filter>
);

export default AdverseFilter;
